<!-- loading spinner -->
<div *ngIf="loading" class="text-center">
  <p-progressSpinner></p-progressSpinner>
</div>
<!-- form -->
<form *ngIf="!loading" [formGroup]="form" class="validated-form">

  <div class="field grid">
    <label class="col-fixed">Show Workgroups?</label>
    <div class="col">
      <p-inputSwitch formControlName="ShowWorkGroups"></p-inputSwitch>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Enable Flexible Workgroups?</label>
    <div class="col">
      <p-inputSwitch formControlName="EnableFlexibleWorkgroups"></p-inputSwitch>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Assigning Forms to Individuals</label>
    <div class="col-fixed dropdown-field">
      <p-dropdown hideDropdownOnScroll [options]="formsToIndividualsOptions | mapList"
                  formControlName="AssigningFormsToIndividuals" id="formsToIndividuals"></p-dropdown>
    </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Assigning Forms to Individuals (Default)</label>
      <div class="col-fixed dropdown-field">
        <p-dropdown hideDropdownOnScroll [options]="formsToindividualsDefaultOptions | mapList"
                    formControlName="AssigningFormsToIndividualsDefault" id="formsToindividualsDefault"></p-dropdown>
      </div>
  </div>

  <div class="field grid">
      <label class="col-fixed"></label>
      <div class="col">
        <p-checkbox [formControl]="form.controls['UpdateFormsDesignsNow']" label="Update forms/designs now"
                    binary="true"></p-checkbox>
      </div>
  </div>

  <div class="field grid">
    <label class="col-fixed">Send Emails to users when assigning forms (Default)</label>
    <div class="col">
      <p-inputSwitch formControlName="SendEmailOnFormAssignment"></p-inputSwitch>
    </div>
  </div>

  <mojo-periodic-email-settings
    #periodicEmailSettings
    [displayMode]="DM.SystemDefaults"
    [settingsTuple]="periodicEmailSettingsTuple"
    (settingsChanged)="periodicEmailSettingsChanged($event)"></mojo-periodic-email-settings>

</form>
